import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import App from './App';
import './sass/main.scss';
import './i18n';

import { Loader } from './components/shared';
import { BrowserRouter } from 'react-router-dom';
import { NODE_ENV } from './config/env';

// Ant Design / browser quirk: harmless ResizeObserver noise should not crash the dev overlay.
const resizeObserverLoopErrRe = /^ResizeObserver loop/;

window.addEventListener(
  'error',
  e => {
    if (resizeObserverLoopErrRe.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

if (typeof window.ResizeObserver !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        {NODE_ENV !== 'production' && (
          <Helmet>
            <meta name="robots" content="noindex, nofollow" />
          </Helmet>
        )}

        <App />
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root'),
);
